class FilterUtils {
  static FilterTable = (row: any, tableDataFilter: {[key: string]: string}) => {
    let keys = Object.keys(row);
    for (let indexKey = 0; indexKey < keys.length; indexKey++) {
      const key = keys[indexKey];
      if (tableDataFilter[key]) {
        if (row != undefined && row[key] != null) {
          if (tableDataFilter[key] !== "") {
            if (
              row[key]
                .toString()
                .toLowerCase()
                .includes(tableDataFilter[key].toString().toLowerCase()) == false
            ) {
              return false;
            }
          }
        } else {
          return false;
        }
      }
    }
    return true;
  }
}

export default FilterUtils